/**
 * 兼容了IOP接口的返回处理
 * WWUtils,WWMethods引入与门店管理组件有区别
 */
import React from 'react';
import {Spin, Tree, message,Checkbox } from 'antd';
import MyAutoComplete from './MyAutoComplete';
const TreeNode = Tree.TreeNode;
import styles from './index.scss'
import {WWUtils,WWMethods} from "@/tools";
export default class SimpleTree extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            userData: null,
            organizationId: this.props.organizationId ? this.props.organizationId : localStorage.getItem("organizationId"),
            expandedKeys: [this.props.organizationId ? String(this.props.organizationId) : localStorage.getItem("organizationId")],
            defaultSelectedKeys: [this.props.organizationId ? String(this.props.organizationId) : localStorage.getItem("organizationId")],
            autoExpandParent: true,
            selectedKeys: [this.props.organizationId ? String(this.props.organizationId) : localStorage.getItem("organizationId")],
            showTree: 'none',
            searchUrl:WWMethods.getApiUrl("searchUrlBrief")+"?length=5&content=",
            treeVisible:false,
            width:"90%",
            popVisible:false,
            parentClass:this.props.parentClass,
            showRootName:this.props.showRootName,
            showSearchInput:true,
            isShowTakeSub:false,
            isTakeSub:false,
            orgName:"",
            isNeedOffLineCount:this.props.isNeedOffLineCount?1:0,
            ATClassName: this.props.ATClassName || 'AT_simpleTree',
            noCount:this.props.noCount || false
        };
        this.onSelect = this.onSelect.bind(this);
        this.onExpand = this.onExpand.bind(this);
        this.getNodeTitle = this.getNodeTitle.bind(this);
        this.loadCustomerTree = this.loadCustomerTree.bind(this);
        this.loadCustomerTree2 = this.loadCustomerTree2.bind(this);
        this.onLoadData = this.onLoadData.bind(this);
        this.loop = this.loop.bind(this);
        this.setSelectedKeys = this.setSelectedKeys.bind(this);
        this.positionCustomerNode = this.positionCustomerNode.bind(this);
        this.setTreeShow = this.setTreeShow.bind(this);
        this.setValue = this.setValue.bind(this);
        this.sendAccountId = this.sendAccountId.bind(this);
        this.hideTree = this.hideTree.bind(this);
        this.clearInput = this.clearInput.bind(this);
        this.selectName = this.selectName.bind(this);
        this.deepToRoot = this.deepToRoot.bind(this);
        this.getAllParentAccount = this.getAllParentAccount.bind(this);
        this.setSearchTreeVisible = this.setSearchTreeVisible.bind(this);
        this.togglePopVisible = this.togglePopVisible.bind(this);
        this.changeSimpleUrl = this.changeSimpleUrl.bind(this);
        this.chagneOrganizationId = this.chagneOrganizationId.bind(this);
        this.updateDatas_simple = this.updateDatas_simple.bind(this);
        this.refreshSetId = this.refreshSetId.bind(this);
        this.onBodyClick = this.onBodyClick.bind(this);
        this.toggleCheckTakeSub = this.toggleCheckTakeSub.bind(this);
    }

    componentWillMount() {

    }

    componentDidMount() {
        this.loadCustomerTree(this.state.organizationId);
        if (this.props.selectedKeys) {
            this.setSelectedKeys(this.props.selectedKeys);
        }
        if (this.props.ownerName) {
            this.refs.selectInput.setValue(this.props.ownerName);
        }

        document.body.addEventListener("click", this.onBodyClick);
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.selectedKeys !== this.props.selectedKeys) {
            this.setSelectedKeys(nextProps.selectedKeys);
        }
        if (nextProps.ownerName !== this.props.ownerName) {
            this.refs.selectInput.setValue(nextProps.ownerName);
        }
        if (nextProps.searchUrl != this.props.searchUrl) {
            this.setState({
                searchUrl:nextProps.searchUrl
            })
        }
        if (nextProps.treeVisible != this.props.treeVisible) {
            this.setState({
                treeVisible:nextProps.treeVisible
            })
        }
        if (nextProps.popVisible != this.props.popVisible) {
            this.setState({
                popVisible:nextProps.popVisible
            })
        }
        if (nextProps.parentClass != this.props.parentClass) {
            this.setState({
                parentClass:nextProps.parentClass
            })
        }
        if (nextProps.showRootName != this.props.showRootName) {
            this.setState({
                showRootName:nextProps.showRootName
            })
        }
        if (nextProps.isShowTakeSub != this.state.isShowTakeSub) {
            this.setState({
                isShowTakeSub:nextProps.isShowTakeSub,
                isTakeSub:nextProps.isTakeSub
            })
        }
    }

    componentWillUnmount() {
        document.body.removeEventListener('click', this.onBodyClick);
    }

    setSearchTreeVisible(data){
        this.setState({
            treeVisible:data
        })
    }
    togglePopVisible(data){
        this.setState({
            popVisible:data
        })
    }
    changeSimpleUrl(url){
        this.setState({
            searchUrl:url
        })
    }
    chagneOrganizationId(organizationId){
        if(this.props.getOrgId){
            this.props.getOrgId(organizationId)
        }
    }
    updateDatas_simple(data){
        this.setState({
            treeVisible:data.treeVisible,
            popVisible:data.popVisible,
            searchUrl:data.searchUrl,
            organizationId:data.organizationId
        },()=>{
            this.getAllParentAccount(data.organizationId)
        })
    }
    refreshSetId(data){
        this.setState({
            refresh_f:data.refresh_f,
            organizationId:data.organizationId
        })
    }
    //展开所有父节点并定位
    getAllParentAccount(organizationId) {
        let url = `${WWMethods.getApiUrl("allParents",this.props.platform)}${organizationId}`;
        let that = this;
        WWUtils.fetch(url,'GET',(data)=>{
            if ((data && data.resultStatusBean) || (data && data.data)) {
                if ((data.code === 0) ||(data.resultStatusBean && data.resultStatusBean.code === 0)) {
                    if (data.data instanceof Array) {
                        let expandedKeys = [];
                        data.data.map(function (item) {
                            expandedKeys.push(String(item.organizationId));
                        });
                        that.deepToRoot(expandedKeys, organizationId);
                    }
                }else if((data.code ===40010) || (data.resultBean && data.resultBean.code === 40010)){
                    message.error(data.message || data.resultBean.result)
                }
            }
        })
    }
    deepToRoot(expandedKeys,organizationId){
        let url = WWMethods.getApiUrl("expandTree",this.props.platform)+organizationId;
        let that = this;
        const {isNeedOffLineCount} = that.state;
        if(isNeedOffLineCount){
            url += "&isNeedOffLineCount="+isNeedOffLineCount+"&parentIds="+expandedKeys.join(",");
        }
        WWUtils.fetch(url,'GET',(res)=>{
            if ((res && res.resultBean) || res.data) {
                if ((res.code === 0) || (res.resultBean.code === 0)  ) {
                    that.chagneOrganizationId(organizationId);
                    let data = res.data;
                    that.setState({
                        userData:data,
                        expandedKeys,
                        selectedKeys: [organizationId.toString()],
                        autoExpandParent: false,
                        organizationId:organizationId.toString()
                    },()=>{
                        setTimeout(function(){
                            //客户节点被选中，执行滚动操作
                            let pClass = that.props.parentClass;
                            let container = $("."+pClass).find('#components-tree-demo-customized-icon'),
                                scrollTo = $("."+pClass).find('#components-tree-demo-customized-icon span.ant-tree-node-selected');
                           // console.log(scrollTo.offset().top ,container.offset().top,container.scrollTop())
                            if (scrollTo.offset()) {
                                container.animate({
                                    scrollTop: scrollTo.offset().top - container.offset().top + container.scrollTop()-600
                                }, 500);
                            }
                        },1000)

                    });


                } else {
                    message.warning(data.message || data.resultBean.result);
                }
            }
        });
    }


    //展开/收起节点时触发
    onExpand(expandedKeys, e) {
        if (e.expanded) {
            this.setState({
                expandedKeys: expandedKeys,
                autoExpandParent: false,
            },()=>{
                !e.node.expanded && !e.node.isLeaf && !e.node.children ?this.loadCustomerTree(e.node.key):null;
            });
        } else {
            if (expandedKeys instanceof Array) {
                let _expandedKeys = expandedKeys.filter(function (item) {
                    return item != e.node.props.eventKey;
                });
                this.setState({
                    expandedKeys: _expandedKeys,
                    autoExpandParent: false,
                });
            }
        }
    }

    //定位到指定客户节点并选中
    positionCustomerNode(treeNodeKeys, organizationId) {
        let that = this;
        let _treeNodeKeys = [];
        if (treeNodeKeys instanceof Array) {
            if (treeNodeKeys.length === 0) {
                treeNodeKeys.push(organizationId);
            }
            that.loadCustomerTree2(_treeNodeKeys.concat(treeNodeKeys), 0, organizationId);
        }
    }
    //异步加载客户节点数据2
    loadCustomerTree2(treeNodeKeys, index, organizationId) {
        this.deepToRoot(treeNodeKeys,organizationId)
    }

    //异步加载客户节点数据
    loadCustomerTree(treeNodeKey, forceRefresh, treeNodeKeys, index, reflsh) {
        if (!forceRefresh) {
            forceRefresh = false;
        }
        let that = this;

        //存儲節點的key值
        if (treeNodeKey) {
            window.treeNodeKey = treeNodeKey;
        }
        const {organizationId, status,isNeedOffLineCount} = this.state;
        let url = WWMethods.getApiUrl("loadTreeUrl",this.props.platform);
        if (treeNodeKeys instanceof Array) {
            if (index == treeNodeKeys.length) {
                return;
            }
            treeNodeKey = treeNodeKeys[index];
        }
        if (treeNodeKey) {
            url = url + "?parentId=" + treeNodeKey;
        } else {
            if (organizationId) {
                url = url + "?parentId=" + organizationId;
            }
        }
        if (status !== undefined) {
            url = url + "&status=" + status;
        }
        if(isNeedOffLineCount) {
            url += '&isNeedOffLineCount='+1;
        }
        that.setState({
            loading: true
        });
        WWUtils.fetch(WWUtils.getNoCacheURL(url),"GET",(res)=>{
            if (res.resultBean || res.data) {
                if ((res.code === 0) || (res.resultBean.code === 0)) {
                    let data = res.data || res;
                    if(isNeedOffLineCount) {
                        data.subOrganizationList = data.subOrganizationList ||  res.subRmsOrgBeanList;
                    }
                    const getUserData = (initUserData, data) => {
                        if (!initUserData) {
                            return data;
                        } else {
                            replaceNodeData(initUserData);
                        }

                        function replaceNodeData(initUserData) {
                            if (initUserData.organizationId === data.organizationId) {
                                let hasChild = false;
                                if (initUserData.subOrganizationList instanceof Array) {
                                    initUserData.subOrganizationList.map(function (item) {
                                        if (item.subOrganizationList instanceof Array) {
                                            hasChild = true;
                                            return false;
                                        }
                                    });
                                }
                                if (forceRefresh) {
                                    initUserData.subOrganizationList = data.subOrganizationList;
                                } else {
                                    if (!hasChild) {
                                        initUserData.subOrganizationList = data.subOrganizationList;
                                    }
                                }
                            } else {
                                if (initUserData instanceof Array) {
                                    initUserData.map(function (item) {
                                        replaceNodeData(item);
                                    })
                                } else if (initUserData.subOrganizationList instanceof Array) {
                                    initUserData.subOrganizationList.map(function (item) {
                                        replaceNodeData(item);
                                    })
                                }
                            }
                        }

                        return initUserData;
                    };
                    let userData = getUserData(that.state.userData, data);
                    that.setState({
                        userData: userData,
                        autoExpandParent:true
                    },()=>{
                        if(that.state.showRootName ) {
                            that.refs.selectInput.setValue(that.state.userData.name);
                            if(that.props.handleChange){
                                that.props.handleChange(organizationId,that.state.userData.name)
                            }
                        }
                    });

                    //递归加载树节点
                    if (treeNodeKeys instanceof Array) {
                        that.loadCustomerTree(null, null, treeNodeKeys, ++index);
                    }

                } else {
                    message.warning(data.message || data.resultBean.result);
                }
            }
        })
    }

    setSelectedKeys(key, nodeName) {
        this.setState({
            selectedKeys: [key],
            organizationId:key,
        }, () => {
            if (this.props.handleChange) {
                if (nodeName) {
                    this.props.handleChange(key, nodeName);
                }
            }
        })
    }

    //选择客户树节点
    onSelect(info, e) {
        let organizationId = info[0];
        let nodeName = e.node.props.nodeName;
        let nodeKey = e.node.props.eventKey;
        let storageAccountId = localStorage.getItem("organizationId");
        const {expandedKeys} = this.state;
        window.treeTitle = nodeName;
        this.refs.selectInput.setValue(nodeName);
        window.init_flag = true;
        if (organizationId) {
            this.setSelectedKeys(organizationId, nodeName);
            //选择节点同时展开节点
            //选择节点同时展开节点
            let _expandedKeys = expandedKeys.filter(function (item) {
                return (item !== organizationId) && (item !== storageAccountId)
            });
            _expandedKeys.push(organizationId);
            _expandedKeys.push(storageAccountId);
            this.setState({
                expandedKeys: _expandedKeys,
                autoExpandParent: false,
                showRootName:false
            }, () => {
                if(!e.node.props.isLeaf){
                    this.loadCustomerTree(organizationId);
                }
            });
        } else {
            if (e.node.props.expanded) {
                if (e.node.props.eventKey !== storageAccountId) {
                    let _expandedKeys = expandedKeys.filter(function (item) {
                        return item !== e.node.props.eventKey
                    });
                    _expandedKeys.push(storageAccountId);
                    this.setState({
                        expandedKeys: _expandedKeys,
                        autoExpandParent: false,
                        showRootName:false
                    });
                }
            } else {
                expandedKeys.push(e.node.props.eventKey);
                this.setState({
                    expandedKeys: expandedKeys,
                    autoExpandParent: false,
                    showRootName:false
                });
            }
        }
        if(this.props.hideDeepTree){
            this.props.hideDeepTree();
        }
    }

    //异步加载树节点
    onLoadData(treeNode) {
        let that = this;
        return new Promise((resolve) => {
            that.loadCustomerTree(treeNode.props.eventKey);
            resolve();
        });
    }


    getNodeTitle(nodeData) {
        const {isNeedOffLineCount,noCount} = this.state;
        if(!isNeedOffLineCount) {
            return nodeData.name;
        } else {
            if(nodeData.offlineSizeStr && !noCount){
                return nodeData.name + ' ' +nodeData.offlineSizeStr;
            }else{
                return nodeData.name;
            }

        }

    }

    loop(userData) {
        const {ATClassName} = this.state;
        const mapper = (item) => {
               if(item.subRmsOrgBeanList){
                   item.subOrganizationList = item.subRmsOrgBeanList
               }
            if (item.subOrganizationList instanceof Array) {
                return this.loop(item)
            } else {
                return (
                    <TreeNode className={ATClassName} nodeName={item.name} title={this.getNodeTitle(item)} key={item.organizationId} isLeaf={item.isLeaf == 0}/>
                )
            }

        };
        if (userData) {
            if (userData instanceof Array) {
                return userData.map(mapper)
            } else if (userData.subOrganizationList instanceof Array || userData.subRmsOrgBeanList instanceof Array) {
                if(userData.subRmsOrgBeanList){
                    userData.subOrganizationList = userData.subRmsOrgBeanList
                }
                return (
                    <TreeNode className={ATClassName} nodeName={userData.name} title={this.getNodeTitle(userData)} key={userData.organizationId} isLeaf={userData.isLeaf == 0}>
                        {userData.subOrganizationList.map(mapper)}
                    </TreeNode>)
            } else {
                return ( <TreeNode className={ATClassName} nodeName={userData.name} title={this.getNodeTitle(userData)}
                                   key={userData.organizationId} isLeaf={userData.isLeaf == 0}/>)
            }
        }
        return null;
    }
    selectName(organizationId,value){
        if(this.props.selectName instanceof Function) {
            this.props.selectName(organizationId,value);
        }
    }
    //是否显示客户树
    setTreeShow(data) {

        setTimeout(()=>{
            //客户节点被选中，执行滚动操作
            let pClass = this.props.parentClass;
            let container = $("."+pClass).find('#components-tree-demo-customized-icon'),
                scrollTo = $("."+pClass).find('#components-tree-demo-customized-icon span.ant-tree-node-selected');
            if (scrollTo.offset()) {
                container.animate({
                    scrollTop: scrollTo.offset().top - container.offset().top + container.scrollTop()-150
                }, 0);
            }
        },500);
        if(this.props.disabled){
            return;
        }
        this.togglePopVisible(true);
    }


    setValue(data) {
        this.refs.selectInput.setValue(data);
    }

    //当匹配到第一个项的时候传id
    sendAccountId(id, accountValue) {
        if (this.props.sendAccountId) {
            this.props.sendAccountId(id, accountValue);
        }
        if (this.props.handleChange) {
            this.props.handleChange(id, accountValue);
        }
    }
    hideTree() {
        this.setState({
            showTree: 'none'
        })
    }
    clearInput(){
        this.refs.selectInput.setState({
            value:""
        })
    }
    onBodyClick(e){
        if(!this.props.disHide && this.state.parentClass && !this.state.treeVisible && !this.state.disabled){
            let x = e.pageX;
            let y = e.pageY;
            let pClass = this.state.parentClass;

            let div = $("."+pClass).eq(0);//获取你想要的DIV
            let searchDiv = $("."+pClass).find("#simpleTree_div").eq(0);//搜索框
            // console.log(div)
            // console.log(searchDiv)
            if(div.offset() && searchDiv.offset()){

                let y1 = div.offset().top;  //div上面两个的点的y值
                let y2 = y1 + div.height();//div下面两个点的y值
                let x1 = div.offset().left;  //div左边两个的点的x值
                let x2 = x1 + div.width();  //div右边两个点的x的值

                let y3 = searchDiv.offset().top;  //div上面两个的点的y值
                let y4 = y3 + searchDiv.height();//div下面两个点的y值
                let x3 = searchDiv.offset().left;  //div左边两个的点的x值
                let x4 = x3 + searchDiv.width();  //div右边两个点的x的值
                // console.log(x>=x1 && x<=x2 &&  y>=y1 && y<=y2)
                // console.log(x>=x3 && x<=x4 && y>=y3 && y<=y4)
                if( (x>=x1 && x<=x2 &&  y>=y1 && y<=y2) || (x>=x3 && x<=x4 && y>=y3 && y<=y4)){
                    // console.log('鼠标在该DIV中');
                }else{
                    // console.log('鼠标在该DIV外');
                    this.togglePopVisible(false);

                }
            }

        }
    }

    toggleCheckTakeSub(e){
        this.setState({
            isTakeSub:e.target.checked
        },()=>{
            this.props.handleChecked(e.target.checked);
        })
    }
    render() {
        const {treeVisible,popVisible,searchUrl,showSearchInput,isShowTakeSub,isTakeSub} = this.state;
        const {userData, expandedKeys, defaultSelectedKeys,width, autoExpandParent, selectedKeys} = this.state;
        const {disabled,widths,heights,left} = this.props;
        let style = {position:treeVisible?"relative":"absolute",height:treeVisible?"":heights?heights:"374px",width:widths?widths:"100%",zIndex:10,background:"#fff",display:popVisible?"flex":"none",flex:"1",flexDirection:"column",maxWidth:'300px'}
        let treeStyle = {
            display:treeVisible?"block":popVisible?"block":"none"
        }
        if(left) {
            style.left = left
        }
        if(heights) {
            treeStyle.height = 434
        }
        return (
            <div className={treeVisible?"":styles.shadowBox_tree} id="simpleTree_div" style={style} >
                <div style={{display:popVisible?"block":"none",height:"38px"}}>
                    <MyAutoComplete width={width}
                                    platform={this.props.platform}
                                    pathType={this.props.pathType}
                                    onSelect={this.onSelect}
                                    positionCustomerNode={(expandedKeys, organizationId)=>
                                    {this.deepToRoot(expandedKeys, organizationId)}}
                                    showTree={this.setTreeShow}
                                    setTreeShow={this.setTreeShow}
                                    sendAccountId={this.sendAccountId}
                                    searchUrl={searchUrl}
                                    disabled={disabled}
                                    selectName={this.selectName}
                                    ATClassName={'AT_simpleTree'}
                                    ref="selectInput" margins={this.props.margins}/>
                </div>
                <div className={styles.checkWrap} style={{display:isShowTakeSub?"block":"none"}}>
                    <Checkbox className={'AT_simpleTree_checkbox1'} onChange={this.toggleCheckTakeSub} checked={isTakeSub}>包含下级</Checkbox>
                </div>
                <Spin spinning={false} size="small" className={treeVisible?styles.treeRelative:styles.treePopDiv}>
                    <div className={treeVisible?styles.treeAutoDiv:styles.treeDiv}
                         id="components-tree-demo-customized-icon" style={treeStyle}>
                        <Tree loadData={null}
                              onSelect={this.onSelect}
                              onExpand={this.onExpand}
                              expandedKeys={expandedKeys}
                              selectedKeys={selectedKeys}
                              showLine
                              autoExpandParent={autoExpandParent}
                              defaultSelectedKeys={defaultSelectedKeys}
                              className="customer_tree">
                            {this.loop(userData)}
                        </Tree>
            </div>
                </Spin>
            </div>
        )
    }
}

